import React, { FormEvent, useEffect, useState } from "react";
import { useAppSelector } from "lib/store";
import styles from './contact.module.css';
import TextInput from "../ContactUs/TextInput";
import TextArea from "../ContactUs/TextArea";
import {
  notificationDismissAllInLocation,
  propertyContactEmail,
  sendGeneralContactFormData,
  getActiveNotificationsMessagesById,
  notificationAdd
} from "_slices/notifications";
import { useDispatch, } from "react-redux";
import { useNotificationLocation } from "lib/hooks/useNotificationLocation";
import RadioInput from "../ContactUs/RadioInput";
import SelectInput from "../ContactUs/SelectInput";
import logEvent from "lib/ga/miscEvent"
import logRepContact from "lib/ga/repContact"
import contactStyle from "../ContactUs/ContactUs.module.css"

type Props = {
  property: {
    name: string,
    type: string,
    id: string,
    hasBid: boolean
    address: {
      line2: string,
      line1: string,
      postcode: string,
      town_name: string
    }
  },
  user: {
    forename: string,
    surname: string,
    email: string,
    telephone: string,
    company: {
      name: string
    }
  },
  agentList: [],
  closeModal: any, googleCat: string, googleType: string, agentId: null | string, premium?: number | null,
  agentListIds: number[]
  mustInclueAgentList: boolean
}

const LocalAgentsContact = ({ property, user, agentList, closeModal, googleCat, googleType, agentId = null, premium = 0, agentListIds, mustInclueAgentList = false }: Props) => {

  let [name, setName] = useState<string>(user ? user.forename + " " + user.surname : "");
  let [email, setEmail] = useState<string>(user ? user.email : "");
  let [phone, setPhone] = useState<string>(user ? user.telephone : "");
  let [company, setCompany] = useState<string>(user && user?.company?.name ? user.company.name : '');
  let [message, setMessage] = useState<string>('');
  let [size, setSize] = useState<string>('');
  let [sizeType, setSizeType] = useState<string>('ft2');
  let [propertyUse, setPropertyUse] = useState<string>('');
  let [budget, setBudget] = useState<string>('');
  let [existingShops, setExistingShops] = useState<string>('');
  let [iWouldLike, setIWouldLike] = useState<string>("email");
  let notification_id = 'MODAL_PROPERTY_LOCAL_CONTACT_FORM';
  const [sendSuccess, activeNotifications] = useNotificationLocation(notification_id);
  let [formSent, setFormSent] = useState(false);

  let dispatch = useDispatch();
  useEffect(() => {
    dispatch(notificationDismissAllInLocation(notification_id));

    return () => { dispatch(notificationDismissAllInLocation(notification_id)); }
  }, [])

  useEffect(() => {
    if (!document.getElementById('recaptchaLoad')) {
      let head = document.getElementsByTagName('head')[0];
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = 'recaptchaLoad';
      script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_KEY}`;
      head.appendChild(script);
    }
  });


  async function formSubmit(e: FormEvent) {
    e.preventDefault();
    setFormSent(true);

    logEvent({
      category: googleCat,
      action: "Email sent",
      label: `Property: ${property.name}`,
      id: property?.id
    });
    logRepContact({
      type: googleType,
      state: "sent",
      target: '',
      id: property?.id,
      subject_type: property?.type
    })

    if (activeNotifications) {
      dispatch(notificationDismissAllInLocation(notification_id));
    }

    let error = false

    if (phone.length < 7) {
      error = true;
      dispatch(notificationAdd({
        location: notification_id,
        state: "error",
        messages: ["You have entered a invalid phone number."],
      }))
      setFormSent(false);
    }

    let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!email.match(mailformat)) {
      error = true;
      dispatch(notificationAdd({
        location: notification_id,
        state: "error",
        messages: ["You have entered a invalid email address."],
      }))
      setFormSent(false);
    }

    if (mustInclueAgentList && (agentListIds && agentListIds.length === 0)) {
      error = true;
      dispatch(notificationAdd({
        location: notification_id,
        state: "error",
        messages: ["At least one agent must be selected."],
      }))
      setFormSent(false);
    }

    if (!error) {

      await grecaptcha.ready(() => {
        // grecaptcha is ready
        grecaptcha
          .execute(process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_KEY, { action: "send_enquiry" })
          .then(async (captcha) => {
            dispatch(notificationDismissAllInLocation(notification_id));
            let schemeName = property.type === 'scheme' ? `${property.name}${property?.address?.town_name ? ` - ${property.address.town_name}` : ''}` : null;
            const propertyName = [property.name, property?.address?.line1,
            property?.address?.line2, property?.address?.town_name,
            property?.address?.postcode].filter(Boolean).join(', ');

            let payload: sendGeneralContactFormData = {
              data: {
                name,
                email,
                phone,
                company,
                iWouldLike,
                message,
                property_type: property.type,
                property_id: property.id,
                property_name: propertyName,
                size: `${size} ${sizeType}`,
                propertyUse,
                budget,
                local_agents: agentList,
                hasBid: property.hasBid ? 1 : 0,
                agent_ids: agentListIds,
                isPremium: premium,
                schemeName: schemeName,
                existingShops
              },
              notification_handle: notification_id
            }
            dispatch(propertyContactEmail(payload));

            setFormSent(false);
          })
      })
    }
  }
  return <div className={`${styles.FormWrapper} ${sendSuccess ? styles.formSuccess : ''}`}>

    <div className={styles.SuccessContainer}>
      <div className={`${styles.SuccessMessage} ${sendSuccess ? styles.successShow : ''}`}>
        <div>Thank You! Your message has been submitted</div>
        <p></p>
        <button className={styles.FancyButton} id="message-sent-close-button" onClick={closeModal}>Close</button>
      </div>
    </div>
    <form className={styles.ContactUsFormGrid}
      id="property-contact-form"
      onSubmit={(e) => formSubmit(e)}>

      <TextInput name="name" label="Name*" value={name} onInputChange={(e) => setName(e)} required={true} placeholder={undefined} type={undefined} />
      <TextInput name="users_email" label="Email Address*" value={email} onInputChange={(e) => setEmail(e)} required={true} placeholder={undefined} type={undefined} />
      <TextInput name="phone" label="Phone Number*" value={phone} onInputChange={(e) => setPhone(e)} required={true} placeholder={undefined} type={undefined} />
      <TextInput name="company" label="Company name" value={company} onInputChange={(e) => setCompany(e)} placeholder={undefined} required={undefined} type={undefined} />

      <div className={styles.AdditionalQuestions}>Agents are more likely to respond if you can provide more information about your business and your requirements. Please answer the following questions.</div>
      <TextInput name="propertyUse" label="How are you going to use the property?*" value={propertyUse} onInputChange={(e) => setPropertyUse(e)} required={true} placeholder={undefined} type={undefined} />
      <div className={styles.sizeInputContainer}>
        <label className={contactStyle.TextInputLabel}> What is your ideal property size? </label>

        <TextInput name="size" type="number" label="" required={true} value={size} onInputChange={(e) => setSize(e)} placeholder={undefined} />

        <SelectInput label="" options={[
          {
            value: 'm2',
            label: 'm2',
            icon: ''
          },
          {
            value: 'ft2',
            label: 'ft2',
            icon: ''
          }
        ]} defaultOption='' value={sizeType} onInputChange={(e) => setSizeType(e)} required={undefined} extraClass={undefined} />
      </div>

      <SelectInput label="What is your rental budget per year?" defaultOption='Select Budget' options={[
        {
          value: 'Up to 10000',
          label: 'Up to 10000',
          icon: ''
        },
        {
          value: '10000 to 20000',
          label: '10000 to 20000',
          icon: ''
        },
        {
          value: '20000 to 30000',
          label: '20000 to 30000',
          icon: ''
        },
        {
          value: '30000 to 50000',
          label: '30000 to 50000',
          icon: ''
        },
        {
          value: '50000 to 100000',
          label: '50000 to 100000',
          icon: ''
        },
        {
          value: 'over 100000',
          label: 'over 100000',
          icon: ''
        }
      ]} required={true} value={budget} onInputChange={(e) => setBudget(e)} extraClass={undefined} />


      <SelectInput label="How many existing shops do you have?*" defaultOption='Select existing shops' options={[
        {
          value: "0",
          label: "None",
          icon: ''
        },
        {
          value: "1",
          label: "1",
          icon: ''
        },
        {
          value: "2",
          label: "2",
          icon: ''
        },
        {
          value: "3",
          label: "3",
          icon: ''
        },
        {
          value: "4",
          label: "4",
          icon: ''
        },
        {
          value: "5 - 10",
          label: "5 - 10",
          icon: ''
        },
        {
          value: "> 10",
          label: "> 10",
          icon: ''
        },
      ]} required={true} value={existingShops} onInputChange={(e) => setExistingShops(e)} extraClass={undefined} />




      <TextArea name="message" label="Any additional information for the agents?" value={message} onInputChange={(e) => setMessage(e)} required={true} placeholder={undefined} extraClass={undefined} />


      <RadioInput template="icon" value={iWouldLike} label="How would you like to be contacted?" name="i_would_like" onInputChange={(e) => {
        logEvent({
          category: "Property Contact",
          action: "I would like",
          label: `value: ${e}`,
        });

        setIWouldLike(e);
      }} options={[
        {
          text: "Contact by Email",
          value: "email"
        },
        {
          text: "A phone call",
          value: "telephone"
        },
      ]} placeholder={undefined} required={undefined} />
      {!sendSuccess && activeNotifications &&
        activeNotifications.map((id) => {
          return <NotificationMessage key={id} id={id} />;
        })}
      <div className={styles.ButtonContainer}>
        <button className={styles.FancyButton} type="submit" >Send</button>
      </div>
    </form>
  </div>
};

interface NotificationMessageProps {
  id: string
}
const NotificationMessage = ({ id }: NotificationMessageProps) => {
  let messages = useAppSelector((state) => getActiveNotificationsMessagesById(id, state));

  return <div className={styles.AlertDanger} key={id}>
    {messages.map((message) => {
      return <div key={id}>{message}</div>;
    })}
  </div>
}

export default LocalAgentsContact;
